<template>
  <div class="card" :size="size">
    <div class="card-image-container">
      <img v-if="company.cover" :src="company.cover" :alt="company.name" class="card-image">
    </div>
    <div class="card-content">
      <div class="card-title">
        {{company.name}}
        <div class="card-actions" v-if="size === 'large'">
          <a v-if="company.phone" :href="`tel:${company.phone}`">
            <i class="el-icon-phone"></i>
          </a>
          <a v-if="company.website" :href="(company.website.startsWith('http') ? '' : 'http://') + company.website" target="_blank">
            <i class="ic ic-website"></i>
          </a>
        </div>
        <div class="card-actions" v-else>
          <i class="el-icon-info"></i>
        </div>
      </div>
      <div class="card-subtitle">{{company.type}}</div>
      <div class="card-address" v-if="company.address">{{company.address}}</div>
      <div class="card-city" v-if="company.address">{{company.city}}, {{company.county}}</div>
      <div class="card-details" v-if="size === 'large'">
        <div class="card-links">
          <a class="card-link" v-if="company.phone" :href="`tel:${company.phone}`">
            <i class="el-icon-phone"></i>
            {{company.phone}}
          </a>
          <a class="card-link" v-if="company.website" :href="(company.website.startsWith('http') ? '' : 'http://') + company.website" target="_blank">
            <i class="ic ic-website"></i>
            <span>{{company.website}}</span>
          </a>
        </div>
        <div class="card-socials">
          <a v-if="company.facebook" :href="company.facebook" class="social fb">
            <i class="ic ic-facebook"></i>
          </a>
          <a v-if="company.twitter" :href="company.twitter" class="social tw">
            <i class="ic ic-twitter"></i>
          </a>
          <a v-if="company.linkedin" :href="company.linkedin" class="social lk">
            <i class="ic ic-linkedin"></i>
          </a>
          <a v-if="company.instagram" :href="company.instagram" class="social instagram">
            <i class="ic ic-instagram"></i>
          </a>
        </div>
        <div class="card-description">{{company.description}}</div>
          <div class="card-gallery" v-if="size === 'large' && company.pictures">
          <a v-for="pic in company.pictures.filter(p => p)" @click="selectedImage = pic" :key="pic" class="card-gallery-image">
            <img alt="" :src="pic">
          </a>
        </div>
      </div>
    </div>
    <div v-if="size === 'large'" class="overlay" fixed :opened="Boolean(selectedImage)" @click="selectedImage = null">
      <div class="dialog auto" @click.stop>
        <a class="ic ic-close" @click="selectedImage = null"></a>
        <img v-if="selectedImage" :src="selectedImage" alt="" class="preview">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCard',
  data() {
    return {
      selectedImage: null
    }
  },
  props: {
    company: {
      type: Object
    },
    size: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style scoped>
.card {
  position: relative;
  display: block;
  border: 1px solid rgba(0, 0, 0, .05);
  box-shadow: 0 8px 16px rgba(136, 152, 170, .15);
  border-radius: 8px;
  font-size: 14px;
  overflow: hidden;
  transition: box-shadow .2s ease-in;
}

#app:not([touch]) .card:hover {
  box-shadow: 0 12px 24px rgba(136, 152, 170, .23);
}

.card-content {
  position: relative;
  padding: 16px 24px;
  max-height: 440px;
  overflow: auto;
}

.card-image-container {
  height: 220px;
}

.card[size="large"] .card-image-container {
  height: 120px;
}

.card-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.card-gallery {
  display: flex;
  flex-flow: row wrap;
  margin: 16px -8px;
}

.card-gallery .card-gallery-image {
  display: block;
  width: calc(25% - 16px);
  height: 80px;
  margin: 0 8px;
}

.card-gallery .card-gallery-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
}

.card-title i.el-icon-info {
  color: #409EFF;
}

.card-actions {
  display: flex;
  align-items: center;
}

.card-actions .ic {
  width: 24px;
  height: 24px;
  margin-left: 8px;
}

.card-actions i {
  display: block;
}

.card-subtitle {
  opacity: .56;
}

.card-address {
  margin-top: 12px;
}

.card-links {
  display: flex;
  margin-top: 8px;
}

.card-links .card-link {
  display: flex;
  justify-content: flex-start;
  width: 50%;
  align-items: center;
}

.card-links .card-link span {
  position: relative;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-links .card-link i {
  flex-shrink: 0;
  margin-right: 8px;
}

.card-socials {
  display: flex;
  margin-top: 8px;
}

.card-socials a {
  margin-right: 8px;
}

.card-socials .ic {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
}

.card-socials .ic:before {
  width: 14px;
  height: 14px;
}

.card-socials .fb .ic {
  background: #2980B7;
}

.card-socials .tw .ic {
  background: #4099FF;
}

.card-socials .gplus .ic {
  background: #DB4E3F;
}

.card-socials .lk .ic {
  background: #0077B5;
}

.card-description {
  margin: 24px 0;
}

.dialog img.preview {
  display: block;
}

@media screen and (max-width: 650px) {
  .card-content {
    max-height: none;
  }
  .card-gallery .card-gallery-image {
    width: calc(50% - 16px);
    margin-top: 8px;
  }
}
</style>
